import { Creatable } from 'react-select'
import createSelect from './createSelect'

export default createSelect(Creatable)
